module.exports = __webpack_public_path__ + "static/media/thumbprintGreen.07abf3cd.svg";